<!--//@*/*
    //    *RPD  App v0.91 fullroster
    //    * Copyright (c) 2024, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

<template>
  <v-data-table
    :headers="headers"
    :items="fullroster"
    sort-by="name"
    class="data-table elevation-1 mt-3"
  >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Data Table</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>

        <!-- dialog -->
        <v-dialog v-model="dialog" max-width="500px">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
              Add New Row
            </v-btn>
          </template>

          <!-- V Card -->
          <v-card class="add-to-roster">
            <v-card-title>
              <span class="text-h5">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row class="">
                  <v-col
                    cols="12"
                    md="12"
                    lg="12"
                    class="d-flex flex-row justify-space-between"
                  >
                    <v-select
                      class="mr-4"
                      id="roster_add_name"
                      v-model="formIn.name"
                      :items="roster_names"
                      label="Name"
                      attach
                    ></v-select>
                    <v-select
                      id="roster_add_present"
                      v-model="formIn.present"
                      :items="roster_present"
                      label="Present"
                      attach
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="12"
                    lg="12"
                    class="d-flex flex-row justify-space-between"
                  >
                    <v-select
                      class="mr-4"
                      id="roster_add_name"
                      v-model="formIn.assignment"
                      :items="roster_assignments"
                      label="Assignment"
                      attach
                    ></v-select>
                    <v-select
                      id="roster_add_team"
                      v-model="formIn.team"
                      :items="roster_teams"
                      label="Team"
                      attach
                    ></v-select>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close"> Cancel </v-btn>
              <v-btn color="blue darken-1" text @click="save"> Save </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogDelete" max-width="500px">
          <v-card>
            <v-card-title class="text-h5"
              >Are you sure you want to delete this item?</v-card-title
            >
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="closeDelete"
                >Cancel</v-btn
              >
              <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                >OK</v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- END DIALOGS -->
      </v-toolbar>
    </template>

    <template v-slot:item.actions="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)">$edit</v-icon>
      <v-icon small @click="deleteItem(item)">$del</v-icon>
    </template>
    <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize"> Reset </v-btn>
    </template> -->
  </v-data-table>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  .data-table {
    width: 96%;
    margin: 0 auto;
  }
  .add-to-roster {
    height: 500px;
  }
}

/* 768 media q */
@media (min-width: 768px) {
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import banner from "./banner.vue";
export default {
  name: "data_table",
  components: {
    banner,
  },
  mixins: [bus_common],

  data: () => ({
    dialog: false,
    dialogDelete: false,
    headers: [
      { text: "Name", align: "start", sortable: false, value: "name" },
      { text: "Present", value: "present" },
      { text: "Assignment", value: "assignment" },
      { text: "Team", value: "team" },
      { text: "Actions", value: "actions", sortable: false },
    ],
    fullroster: [],
    editedIndex: -1,

    /* editItems */
    editedItem: {
      name: "",
      present: "",
      assignment: "",
      team: "",
    },
    defaultItem: {
      name: "",
      present: "",
      assignment: "",
      team: "",
    },

    formIn: {
      name: "",
      present: "",
      assignment: "",
      team: "",
    },

    roster_names: [
      "Autry",
      "Baehr",
      "Butler",
      "Chang",
      "Christensen, B",
      "Clifford",
      "Donigan",
      "Dougherty",
      "Duralde",
      "Espinoza, A",
      "Hakin",
      "Hanna",
      "Hendrix",
      "Hogan",
      "Hoyt",
      "Kent",
      "Kerfoot",
      "Lancaster",
      "Lopey",
      "Mathiowetz",
      "Meseberg",
      "Perham, J",
      "Robles",
      "Rousseau",
      "Schaur",
      "Schmidt",
      "Smith",
      "Sotelo",
      "Struffert",
      "Tom",
      "Tone",
      "Waasdorp",
      "Williams",
      "Ziese",
    ],
    roster_present: ["Yes", "No"],
    roster_assignments: ["TAC1", "TAC2", "TAC3", "ODC", "C2", "Sick"],
    roster_teams: ["RED CELL", "GREEN CELL", "BLUE CELL", "REMSA TEMS", "NONE"],
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "New Roster/Assignment" : "Edit Item";
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    initialize() {
      this.fullroster = [
        {
          name: "Autry",
          present: "Yes",
          assignment: "C2",
          team: "none",
        },
        {
          name: "Robles",
          present: "No",
          assignment: "ODC",
          team: "none",
        },
        {
          name: "Schaur",
          present: "Yes",
          assignment: "ODC",
          team: "Red Cell",
        },
        {
          name: "Meseburg",
          present: "Yes",
          assignment: "TAC3",
          team: "Green Cell",
        },
        {
          name: "Chang",
          present: "Yes",
          assignment: "TAC1",
          team: "REMSA TEMS",
        },
        {
          name: "Espinoza, A",
          present: "Yes",
          assignment: "TAC1",
          team: "Blue Cell",
        },
      ];
    },

    editItem(item) {
      this.editedIndex = this.fullroster.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      this.editedIndex = this.fullroster.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      this.fullroster.splice(this.editedIndex, 1);
      this.closeDelete();
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },

    save() {
      /* if (this.editedIndex > -1) {
        Object.assign(this.fullroster[this.editedIndex], this.editedItem);
      } else { */
      this.fullroster.push(this.formIn);
      /* } */
      this.close();
    },

    message1() {
      alert("This button does nothing yet.");
    },
    init() {},
  },

  /*   methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    init() {},
  }, */

  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
